import { liteClient as algoliasearch } from 'algoliasearch/lite'
import type { LiteClient } from 'algoliasearch/lite'

export const appId = process.env.REACT_APP_ALGOLIA_APP_ID || ''
export const appKey = process.env.REACT_APP_ALGOLIA_APP_KEY || ''

const algoliaClient = algoliasearch(appId, appKey)

type SearchRequest = {
  query?: string
  params?: { query?: string }
  indexName?: string
}

type SearchMethodInput = { requests?: SearchRequest[] } | SearchRequest[]

const getRequests = (searchMethodParams: SearchMethodInput): SearchRequest[] => {
  if (Array.isArray(searchMethodParams)) {
    return searchMethodParams
  }
  return searchMethodParams.requests || []
}

const getQueryFromRequest = (request: SearchRequest): string => {
  if (typeof request.query === 'string') return request.query
  if (request.params && typeof request.params.query === 'string') return request.params.query
  return ''
}

const hasNonEmptyQuery = (requests: SearchRequest[]): boolean =>
  requests.some((request) => getQueryFromRequest(request).trim().length > 0)

const createEmptyResponse = (requests: SearchRequest[]) => ({
  results: requests.map(() => ({
    hits: [],
    nbHits: 0,
    nbPages: 0,
    page: 0,
    processingTimeMS: 0,
    hitsPerPage: 0,
    exhaustiveNbHits: true,
    query: '',
    params: '',
  })),
})

export const searchClient: LiteClient = {
  ...algoliaClient,
  search(searchMethodParams, requestOptions) {
    const requests = getRequests(searchMethodParams as SearchMethodInput)

    if (!hasNonEmptyQuery(requests)) {
      return Promise.resolve(createEmptyResponse(requests))
    }

    return algoliaClient.search(searchMethodParams, requestOptions)
  },
}
